export const conditionalReverse = <T>(array: T[], condition?: boolean): T[] =>
  condition ? array.reverse() : array
